import { Backdrop } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';
import { useDynamicGridContext } from '../useDynamicGridContext';

export const DynamicGridBackdrop = () => {
  const { isCustomizing } = useDynamicGridContext();

  return (
    <Backdrop
      data-testid="dynamic-grid-backdrop"
      open={isCustomizing}
      sx={{
        zIndex: (theme) => theme.zIndex.sidebar + 1,
        opacity: '0.6',
        backgroundColor: tokens.theme.bg.structural.overlayLight,
      }}
    />
  );
};
